import { render, staticRenderFns } from "./ParticipacaoValorTotalDepreciacoesPercentual.vue?vue&type=template&id=288bdc78&scoped=true&"
import script from "./ParticipacaoValorTotalDepreciacoesPercentual.vue?vue&type=script&lang=js&"
export * from "./ParticipacaoValorTotalDepreciacoesPercentual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288bdc78",
  null
  
)

export default component.exports